const buildSaveErrorMessage = (error) => {
  const errors = error?.response?.data?.errors;
  if (!errors) return "Please try again.";
  const messages = Object.entries(errors).map(([key, values]) => {
    const fieldName = key.split(".").pop().replace(/_/g, " ");
    const detail = Array.isArray(values) ? values.join(", ") : values;
    return `${fieldName} ${detail}`;
  });
  return messages.length ? messages.join("; ") : "Please try again.";
};

export default buildSaveErrorMessage;
